import gql from 'graphql-tag';

export interface DexUser {
  id: number;
  name: string;
  email: string;
  role: string;
  descomplicaId: string;
}

export interface GetOrCreateDexUserMutationResult {
  token: string;
  user?: DexUser;
}

export const getOrCreateDexUser = gql`
  mutation getOrCreateDexUser($tokenD: String!) {
    getOrCreateDexUser(tokenD: $tokenD) {
      token
      user {
        id
        name
        email
        role
        descomplicaId
      }
    }
  }
`;
